
import axios from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import { MstMemberVO, BeautyProfileMemberVO } from '@/views/biz/join/vo/join.vo';
import { MstCommonCodeVO } from "@/views/biz/order/vo/order.vo";
import { BeautyProfileOVO , BeautyProfileItemVO} from "@/views/biz/mypage/vo/mypage.vo";

@Component
export default class ProfileIngo extends Vue {
  commonCodes: Array<MstCommonCodeVO> = [] as Array<MstCommonCodeVO>; // 공통코드 (알림구분)
  member: MstMemberVO  = {} as MstMemberVO;  
  beautyProfiles: Array<BeautyProfileOVO> =[] as Array<BeautyProfileOVO>;
  // 파일 트리거


  // computed
  get saveSuccessRouterName(): string {
    return this.$route.params.toName || "Mypage"; // @Prop 으로 못가져옴
  }

  // 최대선택가능
  maxQuantityText(maxQuantity: number): string {
    let text = ""
    if (maxQuantity > 1) {
      text = this.$t("mypage.t0002", [maxQuantity]).toString();
    }
    return text;
  }

  triggerFile() {
    const input = this.$refs.memProfile as HTMLInputElement;
    input.click();
  }
  // 뷰티 프로필 최대 선택 개수 확인
  checkBeautyProfileItem (beautyProfile: BeautyProfileOVO,beautyProfileItem: BeautyProfileItemVO) {
    beautyProfileItem.active = !beautyProfileItem.active;

    if(beautyProfile.beautyProfileCategory.maxQuantity > 1) {      
      if(beautyProfile.beautyProfileItems.filter((item)=>item.active).length > beautyProfile.beautyProfileCategory.maxQuantity) {
        beautyProfileItem.active = !beautyProfileItem.active;
      } 
    } else {  //뷰티프로필 max값 1일때
      beautyProfile.beautyProfileItems.filter((item)=>{
        if(beautyProfileItem != item){
          item.active = false;
        }
          
      })
    }
  }

  // 프로필 사진 업로드
  fileUpload(e) {
    const formData = new FormData();
    formData.append("file", e.target.files[0])
    formData.append("bizType", 'profile')
    // 사진 업로드
    axios.post('/common/file/upload', formData, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(r => {
      const param = {} as MstMemberVO;
      param.memProfileFileCd = r.data[0].fileCd;

      // 회원정보 저장
      axios.put('/mypage/profile', param)
      .then(r => {
        this.member.memProfileFileUrl = r.data.memProfileFileUrl;
      })
    }, err => {
      console.error(err)
    })
  }
  save() {
    if (this.member.instagramLinkUrl && this.member.instagramLinkUrl.indexOf("instagram.com/") < 0) {
      // 유효하지 않은 인스타그램 링크입니다.
      return alert(this.$t("member-info.a0029"));
    }    
    if (this.member.youtubeLinkUrl && this.member.youtubeLinkUrl.indexOf("youtu") < 0) {
      // 유효하지 않은 유튜브 링크입니다.
      return alert(this.$t("member-info.a0030"));
    }    
    if (this.member.naverBlogLinkUrl && this.member.naverBlogLinkUrl.indexOf("blog.naver.com/") < 0) {
      // 유효하지 않은 네이버블로그 링크입니다.
      return alert(this.$t("member-info.a0033"));
    }    
    // 저장하시겠습니까?
    if (confirm(this.$t("common.c0002").toString()) == false) {
      return;
    }
    //뷰티프로필 아이템 담아줌
    this.member.beautyProfiles = [];
    this.beautyProfiles.forEach((r)=>{
      r.beautyProfileItems.filter((p)=>{
        const beautyProfileMemberVO  = {} as BeautyProfileMemberVO;
        beautyProfileMemberVO.beautyCd = p.beautyCd;
        return p.active && this.member.beautyProfiles.push(beautyProfileMemberVO);
      })
    })

    axios.put("/mypage/profile/profile-info", this.member).then((r) => {
      if(r.data == 2){
        // 뷰티 프로필 작성 완료\n500P 지급 완료되었습니다.
        alert(this.$t("member-info.a0031"));
      } else {
        // 저장되었습니다.
        alert(this.$t("member-info.a0024"));
      }
      this.$store.commit("touchKeepAlive");
        this.$router.push({ name: this.saveSuccessRouterName });
    });    
  }
  created() {
    axios.get("/mypage/profile/beautyCategories").then((r) => {        
      this.beautyProfiles = r.data;
    });            
    axios.get(`/common/code/codes/051`).then((r) => {        
      this.commonCodes = r.data;
    });            
    axios.get(`/mypage/profile/profile-info`).then((r) => {
      this.member =r.data;
    })
    .catch((r) => {
      // 뒤로 가기 하니까 URL직접 접근할 때 거시기 됨
      this.$router.push({name: 'Main'});
    });
  }
}
